import React, { useState, useEffect } from 'react'
import { withRouter } from "react-router-dom";
import StatusHeader from './header'
import StatusContainer from './StatusContainer';
import MechanicView from './StatusContainer/JobSteps/MechanicView';
import MobileStatusView from './MobileStatusView';

const StatusPage = (props) => {
    const id = props.match.params.id;
    const isMechanicView = props.location.pathname.includes('mechanic_view');

    const [isMobile, setIsMobile] = useState(() => {
        if (typeof window !== "undefined") {
            return window.innerWidth <= 768;
        }
        return false;
    });

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 768);
        };
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    if (isMechanicView) {
        return (
            <div className="statusBody">
                <StatusHeader />
                <MechanicView id={id} />
            </div>
        );
    }

    if (isMobile) {
        return <MobileStatusView id={id} />;
    }

    return (
        <div className="statusBody">
            <StatusHeader />
            <StatusContainer id={id} />
        </div>
    );
}

export default withRouter(StatusPage);
 